/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

export const selectionTypes = {"STRING":"string","BOOLEAN":"boolean","DATE":"date","DECIMAL":"decimal","SINGLE_SELECT":"single_select","SINGLE_SELECT_WITH_OTHER":"single_select_with_other","MULTI_SELECT":"multi_select"} as const;

export const ONBOARDING_REQUIRED_PARTICIPANT_ATTRIBUTES = ["email","phone","phoneVerified","firstName","lastName","birthDate","location"] as const;

export const attributeTypes = {"INTEGER":"integer","SINGLE_SELECT_WITH_OTHER":"single_select_with_other","DATE":"date","MULTI_SELECT":"multi_select","STRING":"string","SINGLE_SELECT":"single_select","DECIMAL":"decimal","BOOLEAN":"boolean"} as const;

export const PARTICIPANT_SKILLS_LIMIT = 75

const characteristicSlugs = {"AGE":"integer--age","AI_USAGE":"multi_select--ai_usage","ASSISTIVE_TECHNOLOGIES":"multi_select--assistive_technologies_and_custom_settings","BROWSERS":"multi_select--browsers","CHILDREN":"multi_select--children","COMPUTER_OPERATING_SYSTEM":"multi_select--computer_operating_system","DIGITAL_DESIGN_OR_PROTOTYPING_TOOLS":"multi_select--digital_design_prototyping_tools","DISABILITIES":"multi_select--disabilities","EMPLOYMENT_STATUS":"multi_select--employment_status","FOOD_DELIVERY_SERVICES":"multi_select--food_delivery_services","GIG_OR_CONTRACT_OCCUPATIONS":"multi_select--gig_or_contract_occupation_s","HEALTH_AND_WELLNESS_APPS_AND_PLATFORMS":"multi_select--health_and_wellness_apps_platforms","HEALTH_INSURANCE_TYPES":"multi_select--health_insurance_type_s","ONLINE_BANKING_AND_FINANCIAL_MANAGEMENT_TOOLS":"multi_select--online_banking_financial_management_tools","ONLINE_LEARNING_AND_EDUCATION_PLATFORMS":"multi_select--online_learning_educational_platforms","ONLINE_MARKETPLACE_PLATFORMS":"multi_select--online_marketplace_platforms","ONLINE_STREAMING_SERVICES":"multi_select--online_streaming_services","ONLINE_TRAVEL_BOOKING_SERVICES":"multi_select--online_travel_booking_services","OTHER_LANGUAGES_SPOKEN_FLUENTLY":"multi_select--other_language_s_spoken_fluently","PETS_OWNED":"multi_select--pets_owned","PRODUCTIVITY_AND_PROJECT_MANAGEMENT_SOFTWARE":"multi_select--productivity_project_management_software","SKILL":"multi_select--skill","SMART_HOME_AND_GAMING_DEVICES":"multi_select--smart_home_and_gaming_devices","SMARTPHONE_OPERATING_SYSTEM":"multi_select--smartphone_operating_system","SOCIAL_NETWORKING_PLATFORMS":"multi_select--social_networking_platforms","TABLET_OPERATING_SYSTEM":"multi_select--tablet_operating_system","TRADITIONAL_BANKS":"multi_select--traditional_banks","TYPE_OF_INCOME":"multi_select--type_of_income","VEHICLES_OWNED_OR_LEASED":"multi_select--vehicles_currently_owned_or_leased","SAVINGS_INVESTMENT_ACCOUNTS_GB":"multi_select-gb--savings_investment_accounts","SAVINGS_INVESTMENT_ACCOUNTS_US":"multi_select-us--savings_investment_accounts","COMPANY_SIZE":"single_select--company_size","COMPUTER_WITH_A_WEBCAM":"single_select--computer_with_a_webcam","COUNTRY":"single_select--country","ENGLISH_LANGUAGE_PROFICIENCY_SPEAKING":"single_select--english_language_proficiency_-_speaking","GENDER":"single_select--gender","HOME_OWNER":"single_select--home_owner","HOUSEHOLD_INCOME_IN_USD":"single_select--household_income_in_usd","INDUSTRY":"single_select--industry","LEVEL_OF_EDUCATION":"single_select--level_of_education","LIVING_SITUATION":"single_select--living_situation","LOCALITY":"single_select--locality","MARITAL_STATUS":"single_select--marital_status","MILITARY_SERVICE_STATUS":"single_select--military_service_status","NEIGHBORHOOD_TYPE":"single_select--neighborhood_type","OCCUPATION":"single_select--occupation","OCCUPATION_GROUP":"single_select--occupation_group","REGION":"single_select--region","SENIORITY":"single_select--seniority","SMALL_BUSINESS_OWNER":"single_select--small_business_owner","WORK_SETTING":"single_select--work_setting","MOBILE_PHONE_CARRIER_AT":"single_select-at--mobile_phone_carrier","REGION_AT":"single_select-at--region","MOBILE_PHONE_CARRIER_AU":"single_select-au--mobile_phone_carrier","REGION_AU":"single_select-au--region","HOUSEHOLD_INCOME_AUD":"single_select-aud--household_income","MOBILE_PHONE_CARRIER_BE":"single_select-be--mobile_phone_carrier","MOBILE_PHONE_CARRIER_CA":"single_select-ca--mobile_phone_carrier","REGION_CA":"single_select-ca--region","HOUSEHOLD_INCOME_CAD":"single_select-cad--household_income","MOBILE_PHONE_CARRIER_CH":"single_select-ch--mobile_phone_carrier","REGION_CH":"single_select-ch--region","MOBILE_PHONE_CARRIER_DE":"single_select-de--mobile_phone_carrier","REGION_DE":"single_select-de--region","MOBILE_PHONE_CARRIER_DK":"single_select-dk--mobile_phone_carrier","MOBILE_PHONE_CARRIER_ES":"single_select-es--mobile_phone_carrier","HOUSEHOLD_INCOME_EUR":"single_select-eur--household_income","MOBILE_PHONE_CARRIER_FR":"single_select-fr--mobile_phone_carrier","REGION_FR":"single_select-fr--region","MOBILE_PHONE_CARRIER_GB":"single_select-gb--mobile_phone_carrier","REGION_GB":"single_select-gb--region","HOUSEHOLD_INCOME_GBP":"single_select-gbp--household_income","MOBILE_PHONE_CARRIER_IE":"single_select-ie--mobile_phone_carrier","MOBILE_PHONE_CARRIER_IN":"single_select-in--mobile_phone_carrier","REGION_IN":"single_select-in--region","HOUSEHOLD_INCOME_INR":"single_select-inr--household_income","MOBILE_PHONE_CARRIER_MX":"single_select-mx--mobile_phone_carrier","REGION_MX":"single_select-mx--region","HOUSEHOLD_INCOME_MXN":"single_select-mxn--household_income","MOBILE_PHONE_CARRIER_NL":"single_select-nl--mobile_phone_carrier","REGION_NL":"single_select-nl--region","MOBILE_PHONE_CARRIER_NZ":"single_select-nz--mobile_phone_carrier","REGION_NZ":"single_select-nz--region","HOUSEHOLD_INCOME_NZD":"single_select-nzd--household_income","MOBILE_PHONE_CARRIER_SE":"single_select-se--mobile_phone_carrier","REGION_SE":"single_select-se--region","MOBILE_PHONE_CARRIER_SG":"single_select-sg--mobile_phone_carrier","HOUSEHOLD_INCOME_SGD":"single_select-sgd--household_income","MOBILE_PHONE_CARRIER_US":"single_select-us--mobile_phone_carrier","REGION_US":"single_select-us--region","HOUSEHOLD_INCOME_USD":"single_select-usd--household_income","RACE_ETHNICITY":"single_select_with_other--race_ethnicity"} as const;

// Attributes

export const BROWSERS = {
  displayName: 'Browsers',
  labelName: 'Browsers',
  slug: characteristicSlugs.BROWSERS,
} as const;

export const CHILDREN = {
  displayName: 'Children',
  resetOptionName: "No children",
  defaultOptionName: "No children",
  slug: characteristicSlugs.CHILDREN,
} as const;

export const COMPANY_SIZE = {
  displayName: 'Company size',
  slug: characteristicSlugs.COMPANY_SIZE,
} as const;

export const COMPUTER_OPERATING_SYSTEM = {
  displayName: 'Computer operating system',
  labelName: 'Computer operating systems',
  resetOptionName: "N/A - I don't own a computer",
  defaultOptionName: "N/A - I don't own a computer",
  slug: characteristicSlugs.COMPUTER_OPERATING_SYSTEM,
} as const;

export const COMPUTER_WITH_WEBCAM = {
  displayName: 'Computer with a webcam',
  labelName: 'Do you have a computer with a webcam?',
  slug: characteristicSlugs.COMPUTER_WITH_A_WEBCAM,
} as const;

export const EMPLOYMENT_STATUS = {
  displayName: 'Employment status',
  slug: characteristicSlugs.EMPLOYMENT_STATUS,
} as const;

export const ETHNICITY = {
  displayName: 'Race / Ethnicity',
  labelName: 'Race / Ethnicity',
  slug: characteristicSlugs.RACE_ETHNICITY,
} as const;

export const GENDER = {
  displayName: 'Gender',
  slug: characteristicSlugs.GENDER,
} as const;

export const HOME_OWNER = {
  displayName: 'Home owner',
  slug: characteristicSlugs.HOME_OWNER,
} as const;

export const HOUSEHOLD_INCOME = {
  displayName: 'Household income in USD',
  labelName: 'Household income per year',
  slug: characteristicSlugs.HOUSEHOLD_INCOME_IN_USD,
} as const;

export const INDUSTRY = {
  displayName: 'Industry',
  slug: characteristicSlugs.INDUSTRY,
} as const;

export const LEVEL_OF_EDUCATION = {
  displayName: 'Level of education',
  labelName: 'Highest level of education',
  slug: characteristicSlugs.LEVEL_OF_EDUCATION,
} as const;

export const LIVING_SITUATION = {
  displayName: 'Living situation',
  slug: characteristicSlugs.LIVING_SITUATION,
} as const;

export const MARITAL_STATUS = {
  displayName: 'Marital status',
  slug: characteristicSlugs.MARITAL_STATUS,
} as const;

export const SMALL_BUSINESS_OWNER = {
  displayName: 'Small business owner',
  labelName: 'Small business owner?',
  slug: characteristicSlugs.SMALL_BUSINESS_OWNER,
} as const;

export const SMARTPHONE_OPERATING_SYSTEM = {
  displayName: 'Smartphone operating system',
  labelName: 'Smartphone operating systems',
  resetOptionName: "N/A - I don't own a smartphone",
  defaultOptionName: "N/A - I don't own a smartphone",
  slug: characteristicSlugs.SMARTPHONE_OPERATING_SYSTEM,
} as const;

export const TABLET_OPERATING_SYSTEM = {
  displayName: 'Tablet operating system',
  labelName: 'Tablet operating systems',
  resetOptionName: "N/A - I don't own a tablet",
  defaultOptionName: "N/A - I don't own a tablet",
  slug: characteristicSlugs.TABLET_OPERATING_SYSTEM,
} as const;

export const TYPE_OF_INCOME = {
  displayName: 'Type of income',
  resetOptionName: "None of the above",
  defaultOptionName: "None of the above",
  slug: characteristicSlugs.TYPE_OF_INCOME,
} as const;

// Social links

export const SOCIAL_LINK_TYPES = {
  FACEBOOK: 'facebook',
  LINKEDIN: 'linkedin',
  OTHER: 'other',
} as const;

// Columns

export const BIRTH_DATE = {
  displayName: 'Birth date',
  formName: 'birthDate',
  labelName: 'Date of birth',
} as const;

export const COMPANY = {
  formName: 'company',
  labelName: 'Company',
} as const;

export const EMAIL = {
  formName: 'email',
  labelName: 'Email',
} as const;

export const FACEBOOK_LINK = {
  formName: SOCIAL_LINK_TYPES.FACEBOOK,
  labelName: 'Facebook profile',
} as const;

export const FIRST_NAME = {
  formName: 'firstName',
  labelName: 'First name',
} as const;

export const GOOGLE_LOCATION_INFO = {
  formName: 'googleLocationInfo',
  labelName: 'Google location info',
} as const;

export const JOB_TITLE = {
  formName: 'occupationLink',
  labelName: 'Job title',
} as const;

export const LINKEDIN_LINK = {
  formName: SOCIAL_LINK_TYPES.LINKEDIN,
  labelName: 'LinkedIn profile',
} as const;

export const OTHER_SOCIAL_LINK = {
  formName: SOCIAL_LINK_TYPES.OTHER,
  labelName: 'Other',
} as const;

export const SENIORITY = {
  displayName: 'Seniority',
  formName: 'seniority',
  labelName: 'Seniority',
  slug: characteristicSlugs.SENIORITY,
} as const;

export const SKILLS = {
  displayName: 'Skills',
  formName: 'participantSkills',
  labelName: 'Skills'
} as const;

export const LAST_NAME = {
  formName: 'lastName',
  labelName: 'Last name',
} as const;

export const LOCATION = {
  formName: 'location',
  labelName: 'City',
} as const;

export const PHONE = {
  formName: 'phone',
  labelName: 'Phone',
} as const;

export const PHONE_VERIFIED = {
  formName: 'phoneVerified',
  labelName: '',
} as const;

export const PHONE_VERIFICATION_CODE = {
  formName: 'verificationCode',
  labelName: "Let's verify your phone number!",
} as const;

export const TWO_FACTOR_AUTHENTICATION = {
  formName: 'twoFactorEnabled',
  labelName: '',
} as const;
// Other

export const SKIP_PROFESSIONAL_STUDIES = {
  formName: 'skipProfessionalStudies',
  labelName: 'Skip professional studies',
} as const;

export const WORK_EMAIL = {
  formName: 'workEmail',
  labelName: 'Work email',
} as const;

// Occupation options
const FULL_TIME_EMPLOYEE = {
  displayName: 'Full-time employed',
} as const;

const PART_TIME_EMPLOYEE = {
  displayName: 'Part-time employed',
} as const;

// No occupation options
const FULL_TIME_STUDENT = {
  displayName: 'Part-time student',
} as const;

const HOMEMAKER = {
  displayName: 'Homemaker',
} as const;

const PART_TIME_STUDENT = {
  displayName: 'Full-time student',
} as const;

const RETIRED = {
  displayName: 'Retired',
} as const;

const UNEMPLOYED = {
  displayName: 'Unemployed',
} as const;

export const OCCUPATION_DISPLAY_NAMES = [
  FULL_TIME_EMPLOYEE.displayName,
  PART_TIME_EMPLOYEE.displayName,
] as const;

export const NO_OCCUPATION_DISPLAY_NAMES = [
  FULL_TIME_STUDENT.displayName,
  HOMEMAKER.displayName,
  PART_TIME_STUDENT.displayName,
  RETIRED.displayName,
  UNEMPLOYED.displayName,
] as const;

// These three correspond to the machine_name on participant attributes (which is currently just a
// derivative of display name) which hopefully brings us a bit closer to supporting multiple
// languages. At one point I had looked into pulling these constants from the DB on build but that
// wouldn't update in case of a migration since we wouldn't be rebuilding these. :( M.D.
export const DEMOGRAPHIC_ATTRIBUTES = [
  'AGE',
  'RACE_ETHNICITY',
  'CHILDREN',
  'GENDER',
  'HOME_OWNER',
  'PERSONAL_INCOME_IN_USD',
  'HOUSEHOLD_INCOME_IN_USD',
  'LEVEL_OF_EDUCATION',
  'LIVING_SITUATION',
  'MARITAL_STATUS',
] as const;

export const PROFESSIONAL_ATTRIBUTES = [
 'COMPANY_SIZE',
 'EMPLOYMENT_STATUS',
 'INDUSTRY',
 'TYPE_OF_INCOME',
 'SMALL_BUSINESS_OWNER',
] as const;

export const TECHNICAL_ATTRIBUTES = [
  'BROWSERS',
  'COMPUTER_WITH_A_WEBCAM',
  'TABLET_OPERATING_SYSTEM',
  'COMPUTER_OPERATING_SYSTEM',
  'SMARTPHONE_OPERATING_SYSTEM',
] as const;

export const AGE_ATTRIBUTE_NAME = 'Age';

export const DEMOGRAPHIC_ATTRIBUTE_SLUGS = [
  characteristicSlugs.CHILDREN,
  characteristicSlugs.GENDER,
  characteristicSlugs.HOME_OWNER,
  characteristicSlugs.HOUSEHOLD_INCOME_IN_USD,
  characteristicSlugs.LEVEL_OF_EDUCATION,
  characteristicSlugs.LIVING_SITUATION,
  characteristicSlugs.MARITAL_STATUS,
  characteristicSlugs.RACE_ETHNICITY,
] as const;

export const PROFESSIONAL_ATTRIBUTE_SLUGS = [
  characteristicSlugs.COMPANY_SIZE,
  characteristicSlugs.EMPLOYMENT_STATUS,
  characteristicSlugs.INDUSTRY,
  characteristicSlugs.TYPE_OF_INCOME,
  characteristicSlugs.SMALL_BUSINESS_OWNER,
] as const;

export const TECHNICAL_ATTRIBUTE_SLUGS = [
  characteristicSlugs.BROWSERS,
  characteristicSlugs.COMPUTER_OPERATING_SYSTEM,
  characteristicSlugs.COMPUTER_WITH_A_WEBCAM,
  characteristicSlugs.SMARTPHONE_OPERATING_SYSTEM,
  characteristicSlugs.TABLET_OPERATING_SYSTEM,
] as const;

export const AI_USAGE_SLUG = characteristicSlugs.AI_USAGE;
export const ASSISTIVE_TECHNOLOGIES_SLUG = characteristicSlugs.ASSISTIVE_TECHNOLOGIES;
export const BROWSERS_SLUG = characteristicSlugs.BROWSERS;
export const CHILDREN_SLUG = characteristicSlugs.CHILDREN;
export const COMPANY_SIZE_SLUG = characteristicSlugs.COMPANY_SIZE;
export const COMPUTER_OS_SLUG = characteristicSlugs.COMPUTER_OPERATING_SYSTEM;
export const COMPUTER_WEBCAM_SLUG = characteristicSlugs.COMPUTER_WITH_A_WEBCAM;
export const DIGITAL_DESIGN_OR_PROTOTYPING_TOOLS_SLUG = characteristicSlugs.DIGITAL_DESIGN_OR_PROTOTYPING_TOOLS;
export const DISABILITIES_SLUG = characteristicSlugs.DISABILITIES;
export const EMPLOYMENT_STATUS_SLUG = characteristicSlugs.EMPLOYMENT_STATUS;
export const ENGLISH_LANGUAGE_PROFICIENCY_SPEAKING_SLUG = characteristicSlugs.ENGLISH_LANGUAGE_PROFICIENCY_SPEAKING;
export const FOOD_DELIVERY_SERVICES_SLUG = characteristicSlugs.FOOD_DELIVERY_SERVICES;
export const GENDER_SLUG = characteristicSlugs.GENDER;
export const GIG_OR_CONTRACT_OCCUPATIONS_SLUG = characteristicSlugs.GIG_OR_CONTRACT_OCCUPATIONS;
export const HEALTH_AND_WELLNESS_APPS_AND_PLATFORMS_SLUG = characteristicSlugs.HEALTH_AND_WELLNESS_APPS_AND_PLATFORMS;
export const HEALTH_INSURANCE_TYPES_SLUG = characteristicSlugs.HEALTH_INSURANCE_TYPES;
export const HOME_OWNER_SLUG = characteristicSlugs.HOME_OWNER;
export const HOUSEHOLD_INCOME_SLUG = characteristicSlugs.HOUSEHOLD_INCOME_IN_USD;
export const HOUSEHOLD_INCOME_AUD_SLUG = characteristicSlugs.HOUSEHOLD_INCOME_AUD;
export const HOUSEHOLD_INCOME_CAD_SLUG = characteristicSlugs.HOUSEHOLD_INCOME_CAD;
export const HOUSEHOLD_INCOME_EUR_SLUG = characteristicSlugs.HOUSEHOLD_INCOME_EUR;
export const HOUSEHOLD_INCOME_GBP_SLUG = characteristicSlugs.HOUSEHOLD_INCOME_GBP;
export const HOUSEHOLD_INCOME_INR_SLUG = characteristicSlugs.HOUSEHOLD_INCOME_INR;
export const HOUSEHOLD_INCOME_MXN_SLUG = characteristicSlugs.HOUSEHOLD_INCOME_MXN;
export const HOUSEHOLD_INCOME_NZD_SLUG = characteristicSlugs.HOUSEHOLD_INCOME_NZD;
export const HOUSEHOLD_INCOME_SGD_SLUG = characteristicSlugs.HOUSEHOLD_INCOME_SGD;
export const HOUSEHOLD_INCOME_USD_SLUG = characteristicSlugs.HOUSEHOLD_INCOME_USD;
export const INDUSTRY_SLUG = characteristicSlugs.INDUSTRY;
export const LEVEL_OF_EDUCATION_SLUG = characteristicSlugs.LEVEL_OF_EDUCATION;
export const LIVING_SITUATION_SLUG = characteristicSlugs.LIVING_SITUATION;
export const MARITAL_STATUS_SLUG = characteristicSlugs.MARITAL_STATUS;
export const MILITARY_SERVICE_STATUS_SLUG = characteristicSlugs.MILITARY_SERVICE_STATUS;
export const NEIGHBORHOOD_TYPE_SLUG = characteristicSlugs.NEIGHBORHOOD_TYPE;
export const ONLINE_BANKING_AND_FINANCIAL_MANAGEMENT_TOOLS_SLUG = characteristicSlugs.ONLINE_BANKING_AND_FINANCIAL_MANAGEMENT_TOOLS;
export const ONLINE_LEARNING_AND_EDUCATION_PLATFORMS_SLUG = characteristicSlugs.ONLINE_LEARNING_AND_EDUCATION_PLATFORMS;
export const ONLINE_MARKETPLACE_PLATFORMS_SLUG = characteristicSlugs.ONLINE_MARKETPLACE_PLATFORMS;
export const ONLINE_STREAMING_SERVICES_SLUG = characteristicSlugs.ONLINE_STREAMING_SERVICES;
export const ONLINE_TRAVEL_BOOKING_SERVICES_SLUG = characteristicSlugs.ONLINE_TRAVEL_BOOKING_SERVICES;
export const OTHER_LANGUAGES_SPOKEN_FLUENTLY_SLUG = characteristicSlugs.OTHER_LANGUAGES_SPOKEN_FLUENTLY;
export const PETS_OWNED_SLUG = characteristicSlugs.PETS_OWNED;
export const PRODUCTIVITY_AND_PROJECT_MANAGEMENT_SOFTWARE_SLUG = characteristicSlugs.PRODUCTIVITY_AND_PROJECT_MANAGEMENT_SOFTWARE;
export const RACE_ETHNICITY_SLUG = characteristicSlugs.RACE_ETHNICITY;
export const SAVINGS_INVESTMENT_ACCOUNTS_US_SLUG = characteristicSlugs.SAVINGS_INVESTMENT_ACCOUNTS_US;
export const SAVINGS_INVESTMENT_ACCOUNTS_GB_SLUG = characteristicSlugs.SAVINGS_INVESTMENT_ACCOUNTS_GB;
export const SENIORITY_SLUG = characteristicSlugs.SENIORITY;
export const SMALL_BUSINESS_OWNER_SLUG = characteristicSlugs.SMALL_BUSINESS_OWNER;
export const SMART_HOME_AND_GAMING_DEVICES_SLUG = characteristicSlugs.SMART_HOME_AND_GAMING_DEVICES;
export const SMARTPHONE_OS_SLUG = characteristicSlugs.SMARTPHONE_OPERATING_SYSTEM;
export const SOCIAL_NETWORKING_PLATFORMS_SLUG = characteristicSlugs.SOCIAL_NETWORKING_PLATFORMS;
export const TABLET_OS_SLUG = characteristicSlugs.TABLET_OPERATING_SYSTEM;
export const TRADITIONAL_BANKS_SLUG = characteristicSlugs.TRADITIONAL_BANKS;
export const TYPE_OF_INCOME_SLUG = characteristicSlugs.TYPE_OF_INCOME;
export const WORK_SETTING_SLUG = characteristicSlugs.WORK_SETTING;
export const VEHICLES_OWNED_OR_LEASED_SLUG = characteristicSlugs.VEHICLES_OWNED_OR_LEASED;

// Attributes included in workspace filter schema
export const INCLUDED_WORKSPACE_ATTRIBUTE_SLUGS = ["multi_select--ai_usage","multi_select--browsers","multi_select--children","multi_select--computer_operating_system","multi_select--digital_design_prototyping_tools","multi_select--employment_status","single_select--english_language_proficiency_-_speaking","multi_select--food_delivery_services","single_select--gender","multi_select--gig_or_contract_occupation_s","multi_select--health_and_wellness_apps_platforms","multi_select--health_insurance_type_s","single_select--home_owner","single_select--household_income_in_usd","single_select-aud--household_income","single_select-cad--household_income","single_select-eur--household_income","single_select-gbp--household_income","single_select-inr--household_income","single_select-mxn--household_income","single_select-nzd--household_income","single_select-sgd--household_income","single_select-usd--household_income","single_select--level_of_education","single_select--living_situation","single_select--marital_status","single_select--military_service_status","single_select--neighborhood_type","multi_select--online_banking_financial_management_tools","multi_select--online_learning_educational_platforms","multi_select--online_marketplace_platforms","multi_select--online_streaming_services","multi_select--online_travel_booking_services","multi_select--other_language_s_spoken_fluently","multi_select--pets_owned","multi_select--productivity_project_management_software","single_select_with_other--race_ethnicity","multi_select--smart_home_and_gaming_devices","multi_select--smartphone_operating_system","multi_select--social_networking_platforms","multi_select--tablet_operating_system","multi_select--traditional_banks","multi_select--vehicles_currently_owned_or_leased"] as const;

// Attributes included in workspace filter schema for B2B recruit projects
export const B2B_RECRUIT_PROJECT_FILTER_ATTRIBUTE_SLUGS = ["single_select--company_size","single_select--industry","single_select--seniority","single_select--small_business_owner","multi_select--type_of_income","single_select--work_setting"] as const;

export const CHILDREN_DEFAULT_OPTION_NAME = "No children";
export const COMPUTER_OS_DEFAULT_OPTION_NAME = "N/A - I don't own a computer";
export const SMARTPHONE_OS_DEFAULT_OPTION_NAME = "N/A - I don't own a smartphone";
export const TABLET_OS_DEFAULT_OPTION_NAME = "N/A - I don't own a tablet";
export const TYPE_OF_INCOME_DEFAULT_OPTION_NAME = "None of the above";
